import {Type} from '@angular/core';

export class SptComponentRef {
  constructor(public component: Type<any>, public data: any = null) {}
}
